import React    from 'react'
import {
    StaticQuery,
    graphql
} from 'gatsby'
import {
    filter,
    get
} from 'lodash'

export default (WrappedComponent) => {
    return class extends React.Component {
        render(){
            return <StaticQuery
                query={ graphql`
                    query {
                        parentPages: allWordpressPage(
                            filter: {wordpress_parent: {eq: 0}, acf: {hide_from_menu: {ne: true}}}, 
                            sort: {fields: menu_order, order: ASC}
                        ) {
                            edges {
                                node {
                                    wordpress_id
                                    title
                                    path
                                    acf {
                                        parent_menu_type
                                    }
                                }
                            }
                        }
                        childPages: allWordpressPage(
                            filter: {wordpress_parent: {ne: 0}, acf: {hide_from_menu: {ne: true}}}, 
                            sort: {fields: menu_order, order: ASC}
                        ) {
                            edges {
                                node {
                                    wordpress_id
                                    title
                                    path
                                    wordpress_parent
                                }
                            }
                        }
                    }
                ` }
                render={ (data) => { 
                    const mapLink = (_o) => {
                        return {
                            link: _o.node.path,
                            title: _o.node.title,
                            menuType: get(_o, 'node.acf.parent_menu_type')
                        }
                    }
                    const links = data.parentPages.edges ? data.parentPages.edges.map((_o, _i) => {
                        const _childLinks = filter(data.childPages.edges, (_p, _j) => {
                            return _p.node.wordpress_parent === _o.node.wordpress_id
                        })
                        return {
                            ...mapLink(_o),
                            subLinks: _childLinks && _childLinks.length > 0 ? _childLinks.map(mapLink) : null
                        }
                    }) : null

                    return <WrappedComponent
                        links={ links }
                        { ...this.props }
                        />
                } }
                />
        }
    }
}